module.exports = __webpack_public_path__ + "img/banner2.12a2f73b.png";